import React from 'react';

interface Props {
  total: number;
  current: number;
  onDotClick: (i: number) => void;
}

export const ProgressDots: React.FC<Props> = ({ total, current, onDotClick }) => (
  <div className="bs-dots" role="tablist" aria-label="Slide navigation">
    {Array.from({ length: total }, (_, i) => (
      <button
        key={i}
        role="tab"
        aria-selected={i === current}
        aria-label={`Slide ${i + 1}`}
        className={`bs-dot${i === current ? ' bs-dot--active' : ''}`}
        onClick={() => onDotClick(i)}
      />
    ))}
  </div>
);
